import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'

import Leagues from './pages/Leagues'
import League from './pages/League'
import Suggestions from './pages/Suggestions'
import TradeBuilder from './pages/TradeBuilder'
import TradeExplorer from './pages/TradeExplorer'
import TradeResult from './pages/TradeResult'
import SharedTrade from './pages/SharedTrade'
import TradesList from './pages/TradesList'
import Admin from './pages/Admin'
import AdminUser from './pages/AdminUser'
import Account from './pages/Account'

export default function App() {
  return (
    <div className="min-h-screen bg-slate-950 text-slate-100">
      <Routes>
        <Route path="/" element={<Navigate to="/leagues" replace />} />
        <Route path="/leagues" element={<Leagues />} />

        {/* The page was called Connect for as long as connecting a league was
            the only thing it did. Links to it are out in the world — in the
            Yahoo callback, in bookmarks, in old emails — so the path keeps
            answering rather than 404ing someone who followed one. */}
        <Route path="/connect" element={<Navigate to="/leagues" replace />} />

        <Route path="/leagues/:leagueId" element={<League />} />
        <Route path="/leagues/:leagueId/suggestions" element={<Suggestions />} />
        <Route path="/leagues/:leagueId/trade" element={<TradeBuilder />} />
        <Route path="/leagues/:leagueId/explore" element={<TradeExplorer />} />
        <Route path="/trades" element={<TradesList />} />
        <Route path="/trades/:tradeId" element={<TradeResult />} />
        <Route path="/s/:token" element={<SharedTrade />} />
        <Route path="/account" element={<Account />} />

        {/* Not guarded in the router. The server is the guard: these pages
            render, their queries 404, and the pages say so. A client-side
            check would be decoration over an API that already refuses. */}
        <Route path="/admin" element={<Admin />} />
        <Route path="/admin/users/:userId" element={<AdminUser />} />
      </Routes>
    </div>
  )
}
